theme.lookbookSlider = (function () {
  function lookBook(e) {
    let slideshow = e.querySelector(".lookbook--slider"),
      paginationSelector = e.querySelector(".swiper-pagination"),
      navselectorPrev = e.querySelector(".swiper-button-prev"),
      navselectorNext = e.querySelector(".swiper-button-next");
    var lookbookSlider = new Swiper(slideshow, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: paginationSelector,
        clickable: true,
      },
      autoplay: false,
      autoHeight: false,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        750: {
          slidesPerView: 1,
        },
        992: {
          slidesPerView: 1,
        },
      },
    });
    
    // Lookbook hotspot connect
    const lookbookHotspot = e.querySelectorAll(".lookbook--product-hotspot");
    if (lookbookHotspot.length > 0) {
      lookbookHotspot.forEach((button) => {
        button?.addEventListener("mouseover", function (event) {
          lookbookSlider.slideToLoop(parseInt(button.dataset.index));
          slideshow.classList.add("lookbook__hover--active");
        });
        button?.addEventListener("mouseout", function (event) {
          slideshow.classList.remove("lookbook__hover--active");
        });
      });
    }
    if (lookbookHotspot.length > 0) {
      lookbookHotspot.forEach((button) => {
        button?.addEventListener("click", function (event) {
          lookbookSlider.slideToLoop(parseInt(button.dataset.index));
          slideshow.classList.add("lookbook__hover--active");
        });
      });
    }
    
    // Active class
    lookbookSlider.on("slideChange", function () {
      const realIndex = lookbookSlider.realIndex;
      if (lookbookHotspot.length > 0) {
        lookbookHotspot.forEach((button) => {
          button.classList.remove("active");
          if (parseInt(button.dataset.index) == realIndex) {
            button.classList.add("active");
          }
        });
      }
    });
    
    // Theme editor integration
    if (window.Shopify && window.Shopify.designMode) {
      const sectionId = e.dataset.sectionId;
      
      // Simple function to activate a specific hotspot
      function activateHotspot(hotspot) {
        if (!hotspot || !hotspot.dataset.index) return;
        
        const index = parseInt(hotspot.dataset.index);
        lookbookSlider.slideToLoop(index);
        slideshow.classList.add("lookbook__hover--active");
        
        lookbookHotspot.forEach(btn => btn.classList.remove('active'));
        hotspot.classList.add('active');
      }
      
      // Theme editor block select event
      document.addEventListener('shopify:block:select', function(event) {
        // Check if block belongs to this section
        const blockElement = event.target;
        const blockWrapper = blockElement.closest('.lookbook__shop--product-wrapper');
        
        if (blockWrapper) {
          const hotspot = blockWrapper.querySelector('.lookbook--product-hotspot');
          activateHotspot(hotspot);
        }
      });
      
      // Theme editor block deselect event
      document.addEventListener('shopify:block:deselect', function(event) {
        slideshow.classList.remove("lookbook__hover--active");
      });
    }
  }
  
  return lookBook;
})();